module.exports = "pegasus_template/assets/themecapture1/charity/107.png";